import React from "react"
import { Box, Progress } from "@chakra-ui/react"
import { ProgressContext, ProgressDispatchContext } from "../context/ContextProvider"

export default function ProgressBar() {
  const progressStatus = React.useContext(ProgressContext)
  const setProgressStatus = React.useContext(ProgressDispatchContext)
  return (
    <Box position="fixed" w="100%" top={0} zIndex={2}>
      {progressStatus?.status == true ?
        <Progress isIndeterminate size="sm" colorScheme="orange" color="#f05605" />
        : null
      }
    </Box>
  )
}
